export default class Tabs {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Tabs;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$(document).on('click', '.js-tab-link', function(e){
			e.preventDefault();
			self.openTab($(this));
		});

		let hash = window.location.hash;
		if($('.js-tab-link[href="' + hash + '"]').length) {
			self.openTab($('.js-tab-link[href="' + hash + '"]'));
		}

		$(document).on('click', '.js-scroll-to-end-of-tabs', function(e) {
			e.preventDefault();

			self.scrollToEndOfTabs($('.js-tab-link[href="' + hash + '"]'));
		});
	}

	openTab($link) {
		const self = this;

		let tabId = $link.attr('href'),
			$tab = $(tabId),
			$wrapper = $tab.parents('.tabs');

		if ($wrapper.length > 0) {
			$link = $wrapper.find('[href="' + tabId + '"]');
		} else {
			$wrapper = $link.parents('.tabs');
			$link = $wrapper.find('[href="' + tabId + '"]');
		}

		if (typeof (history.pushState) != "undefined") {
			let url = window.location.href.split('#');
			history.pushState(null, null, url[0] + tabId);
		}

		self.closeTabs($link);

		$link.parent('li').addClass('is-active');

		$tab.addClass('is-active');

		$(document).trigger('tabChange');
	}

	closeTabs($link) {
		const self = this;

		var $wrapper = $link.parents('.tabs'),
			$tabs = $wrapper.find('.tabs-pane'),
			$links = $wrapper.find('.tabs-nav li');

		$links.removeClass('is-active');
		$tabs.removeClass('is-active');
	}

	scrollToEndOfTabs($link) {
		const self = this,
			$list = $link.parents('.tabs-list');

		$list.scrollLeft(300);

	}
}
